export default "Training Goal"